import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    orangeButton: {
        backgroundColor: 'hsl(43deg 100% 46%)',
        color: 'white',
        marginLeft: '20px',
        height: '30px',
        fontSize: '12.5px',
    },
}));
